define.alias("ember-composable-helpers/helpers/has-next", "media/helpers/has-next");